import React, { useState } from "react";
import { AdminSettings, updateAdminSettings } from "../../ApiService";
import TextField from "../../components/TextField/TextField";
import Button from "../../components/Button/Button";
import { Field, Form, FormikProvider, useFormik } from "formik";
import { useMutation, useQueryClient } from "react-query";
import LoaderCircle from "../../components/LoaderCircle/LoaderCircle";

export type SettingsFormProps = {
  adminSettings: AdminSettings;
};

const SettingsForm: React.FC<SettingsFormProps> = ({ adminSettings }) => {
  const [isLoading, setIsLoading] = useState(false);

  const queryClient = useQueryClient();

  const formik = useFormik({
    initialValues: adminSettings,
    onSubmit: (values) => handleSaveSettings(values),
  });

  const { values, handleChange } = formik;

  const updateSettingsMutation = useMutation(updateAdminSettings, {
    onMutate: () => {
      setIsLoading(true);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["adminSettings"]);
      queryClient.refetchQueries("settings");
      console.log("Обновились настройки");
      setIsLoading(false);
    },
    onError: (error) => {
      console.error("Ошибка обновления настроек", error);
      setIsLoading(false);
    },
  });

  const handleSaveSettings = (values: AdminSettings) => {
    updateSettingsMutation.mutate({
      adminLink: values.adminLink,
      secret: values.secret,
      showAdminLink: values.showAdminLink,
    });
  };

  const isChanged = JSON.stringify(adminSettings) !== JSON.stringify(values);

  return (
    <FormikProvider value={formik}>
      {isLoading && <LoaderCircle />}
      <Form>
        <div className="flex flex-col gap-5">
          <div className="flex flex-col xl:flex-row gap-5">
            <div className="flex-1">
              <TextField
                label="Ссылка для связи с администратором"
                name="adminLink"
                type="text"
                placeholder="Введите ссылку для связи"
                onChange={handleChange}
                value={values.adminLink}
              />
            </div>
            <div className="flex-1">
              <TextField
                label="Код-секрет для регистрации нового пользователя"
                name="secret"
                type="text"
                placeholder="Введите секрет"
                onChange={handleChange}
                value={values.secret}
              />
            </div>
          </div>
          <div className="flex flex-row gap-2">
            <Field type="checkbox" name="showAdminLink" />
            <div className="bodySemiboldFont">
              Отображать ссылку для связи с администратором
            </div>
          </div>

          <Button
            type="submit"
            status={isChanged ? "enabled" : "disabled"}
            title="Сохранить изменения"
            style={{ marginTop: 20 }}
          />
        </div>
      </Form>
    </FormikProvider>
  );
};

export default SettingsForm;
